var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkResumen.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledDetalleViaje },
                model: {
                  value: _vm.formFields.checkResumen.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkResumen, "value", $$v)
                  },
                  expression: "formFields.checkResumen.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkAgruparDia.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledDetalleViaje },
                model: {
                  value: _vm.formFields.checkAgruparDia.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkAgruparDia, "value", $$v)
                  },
                  expression: "formFields.checkAgruparDia.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }